// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9bb45fa0","667":"df62075c","977":"b14361a5"}[chunkId] + ".chunk.js";
};